import { createSlice } from '@reduxjs/toolkit';


/**
 * Estado global para ventas de Nota de Crédito.
 */
interface CreditNoteSaleState {
  showAddProductModal: boolean;
  showEditProductModal: boolean;
}

const initialState: CreditNoteSaleState = {
  showAddProductModal: false,
  showEditProductModal: false,
};

const creditNoteSaleSlice = createSlice({
  name: 'creditNoteSale',
  initialState,
  reducers: {
    /**
     * Abre el modal para agregar un nuevo producto.
     */
    openAddProductModal(state) {
      state.showAddProductModal = true;
    },

    /**
     * Cierra el modal de agregar producto.
     */
    closeAddProductModal(state) {
      state.showAddProductModal = false;
    },

    /**
     * Abre el modal de edición de producto.
     */
    openEditProductModal(state) {
      state.showEditProductModal = true;
    },

    /**
     * Cierra el modal de edición de producto.
     */
    closeEditProductModal(state) {
      state.showEditProductModal = false;
    },
  },
});

export const {
  openAddProductModal,
  closeAddProductModal,
  openEditProductModal,
  closeEditProductModal,
} = creditNoteSaleSlice.actions;

export default creditNoteSaleSlice.reducer;
